<app-layout>
  <div class="main">
    <div class="header-table">
      <app-titulo>Tolerância de Agendamento</app-titulo>
    </div>

    <div class="grid-outline desktop">
      <div class="grid-header">
        <div class="intern-title">Configuração</div>
      </div>

      <app-loader [isLoading]="isLoading"></app-loader>

      <form [formGroup]="form" *ngIf="!isLoading" class="settings-form">

        <div class="setting-row">
          <div class="setting-info">
            <div class="setting-label">Tolerância para atraso</div>
            <div class="setting-desc">
              Tempo máximo de atraso permitido após o horário agendado para o caminhão entrar.
            </div>
          </div>
          <div class="setting-input">
            <input
              type="number"
              min="0"
              step="1"
              formControlName="QT_TOLE_ATRS"
              class="hour-input"
            />
            <select
              formControlName="UNIDADE_ATRS"
              class="unit-select"
              (change)="onUnidadeChange('ATRS')"
            >
              <option value="horas">horas</option>
              <option value="minutos">minutos</option>
            </select>
          </div>
        </div>

        <div class="setting-row">
          <div class="setting-info">
            <div class="setting-label">Tolerância para adiantamento</div>
            <div class="setting-desc">
              Tempo máximo de antecedência permitido para o caminhão entrar para o pré-pátio.
            </div>
          </div>
          <div class="setting-input">
            <input
              type="number"
              min="0"
              step="1"
              formControlName="QT_TOLE_ADIA"
              class="hour-input"
            />
            <select
              formControlName="UNIDADE_ADIA"
              class="unit-select"
              (change)="onUnidadeChange('ADIA')"
            >
              <option value="horas">horas</option>
              <option value="minutos">minutos</option>
            </select>
          </div>
        </div>

        <div class="form-footer">
          <app-botao
            type="cadastro"
            text="Salvar alterações"
            [disabled]="!form.valid"
            (click)="salvar()">
          </app-botao>
        </div>

      </form>
    </div>
  </div>
</app-layout>
